





















import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import {
  DataSet,
  moment,
  Timeline,
  TimelineItemType,
} from "vis-timeline/standalone";
import CAMPAIGN_STATUS_LIST from "@/constants/campaign";
import Site from "@/models/site";
import AdUnit from "@/models/adUnit";
import Campaign, { LineItem } from "@/models/campaign";
import { DefinitionList } from "@/models/definition";
import {
  AvailabilityEvent,
  AvailabilityFilterModel,
  AvailabilityNode,
  TimeLineGroup,
  TimeLineItem,
} from "@/models/availability";
import { QueryParams } from "@/models/general";
import CampaignsAPI from "@/services/campaigns";
import DefinitionValue from "@/models/definitionValue";
import AvailabilityDetails from "./AvailabilityDetails.vue";
import { LayoutModule } from "@/store/layout";

@Component({
  // components: { GanttElastic, GanttHeader },
})
export default class TimeLineAvailability extends Vue {
  @Prop({ default: () => [] }) sites!: Site[];
  @Prop({ default: () => [] }) adUnits!: AdUnit[];
  @Prop({ default: () => [] }) campaigns!: Campaign[];
  @Prop({ default: () => [] }) definitions!: DefinitionList[];
  @Prop({ default: null }) filter!: AvailabilityFilterModel;

  timeline?: Timeline;
  lineItems: LineItem[] = [];
  groups: TimeLineGroup[] = [];
  items: TimeLineItem[] = [];
  current_date_range = {
    start: {},
    end: {},
  };
  zoomFactor = 1;

  @Watch("filter", { deep: true })
  applyFilter(): void {
    this.getEvents({ start: this.filter.start, end: this.filter.end });
  }

  async created(): Promise<void> {
    // this.getEvents(this.current_date_range);
    await this.getEvents({ start: this.filter.start, end: this.filter.end });
  }

  mounted(): void {
    this.initTimeLine();
  }

  initTimeLine(): void {
    // eslint-disable-next-line
    const self = this;
    const container = this.$refs.timeline as HTMLElement;

    const options = {
      stack: false,
      start: moment(this.filter.start).toDate(),
      end: moment(this.filter.end).toDate(),
      horizontalScroll: true,
      zoomable: false,
      margin: {
        item: 10,
        axis: 5,
      },
      orientation: "top",
    };
    this.timeline = new Timeline(container, null, options);

    this.timeline.on("select", (e) => {
      // const item = self.items.find((i) => i.id === e.items[0]);
      // console.log("item selected", item);
      // self.showDetails(item?.adUnit.id);
    });
  }

  async getEvents({ start, end }: any): Promise<void> {
    const events: AvailabilityEvent[] = [];
    // const min = new Date(`${start.date}T00:00:00`);
    // const max = new Date(`${end.date}T23:59:59`);
    const min = new Date(start);
    const max = new Date(end);

    this.current_date_range.start = start;
    this.current_date_range.end = end;

    const params: QueryParams = {
      page: {
        size: -1,
      },
      filter: {
        // ad_units: this.filter.ad_units.join(","),
        // site_id: "",
        start: min,
        end: max,
      },
    };

    this.filter !== null && this.filter.ad_units !== undefined
      ? ((params.filter as AvailabilityFilterModel).ad_units = (this.filter
          .ad_units as string[]).join(","))
      : null;

    this.filter !== null && this.filter.site_id !== undefined
      ? ((params.filter as AvailabilityFilterModel).site_id = this.filter.site_id)
      : null;

    const r = await CampaignsAPI.lineItems.all(params);
    this.lineItems = r.data;

    this.groups = this.generateGroups();
    this.items = this.generateItems();

    if (this.timeline) {
      this.timeline.setGroups(this.groups);
      this.timeline.setItems(this.items);
    }
  }

  getCampaign(campaign_id?: string): Campaign {
    const campaign: Campaign | undefined = this.campaigns.find(
      (e) => e.id === campaign_id
    );
    return campaign ? campaign : new Campaign();
  }

  getAdUnit(ad_unit_id: string): AdUnit {
    const adUnit: AdUnit | undefined = this.adUnits.find(
      (e) => e.id === ad_unit_id
    );
    return adUnit ? adUnit : new AdUnit();
  }

  getEventColor(status: string): string | undefined {
    const s = CAMPAIGN_STATUS_LIST.find((e) => e.key === status);
    return s ? s.class : "#CCCCCC";
  }

  generateGroups(): TimeLineGroup[] {
    const groups: TimeLineGroup[] = [];
    const definitionCombinations = this.generateDefinitionCombinations();
    this.adUnits.forEach((a) => {
      if (this.filter.ad_units!.includes(a.id!)) {
        definitionCombinations.forEach((c) => {
          if (
            a.definitionValueIds.includes(c[0].id) &&
            a.definitionValueIds.includes(c[1].id)
          ) {
            groups.push({
              id: `${a.id}${c[0].id}${c[1].id}`,
              content: `${a.name} - ${c[0].name} ${c[1].name}`,
              adUnit: a,
              definitions: c,
            });
          }
        });
      }
    });

    return groups;
  }

  generateItems(): TimeLineItem[] {
    const items: TimeLineItem[] = [];
    this.lineItems.forEach((lineItem) => {
      const g = this.groups.find((g) => {
        return (
          g.id.includes(lineItem.adUnitId) &&
          g.id.includes(lineItem.definitionValueIds[0]) &&
          g.id.includes(lineItem.definitionValueIds[1])
        );
      });
      const campaign = this.getCampaign(lineItem.campaignId);
      const statusName = this.$t(`campaigns.status_list.${campaign.status}`);

      const title = `<span class="tw-font-bold">${
        campaign.name as string
      }</span> - ${moment(lineItem.start).format("DD-MM-YYYY")} / ${moment(
        lineItem.end
      ).format("DD-MM-YYYY")} (${statusName}) | ${
        campaign.user?.displayName
          ? campaign.user?.displayName
          : this.$t("availability.deleted_user")
      }`;

      const i = {
        id: lineItem.id ? (lineItem.id as string) : "",
        content: title,
        start: moment(lineItem.start).format("YYYY-MM-DD") as string,
        end: moment(lineItem.end).format("YYYY-MM-DD") as string,
        className: this.getEventColor(campaign.status) as string,
        title: title,
        group: g ? (g.id as string) : "",
        adUnit: g?.adUnit as AdUnit,
      };

      items.push(new TimeLineItem(i));
    });

    return items;
  }
  generateDefinitionCombinations(): any[] {
    const combinations: any[] = [];

    // TODO: Support more than two definitions
    this.definitions[1].values.forEach((v) => {
      this.definitions[0].values.forEach((e) => {
        const entry: DefinitionValue[] = [];
        entry.push(v);
        entry.push(e);
        combinations.push(entry);
      });
    });

    return combinations;
  }

  showDetails(adUnitId?: string): void {
    const props = {
      // adUnitId: adUnitId,
      // lineItems: this.lineItems,
      // campaigns: this.campaigns,
      // definitions: this.definitions,
      // environment: "homepage",
    };

    LayoutModule.setRightDrawerComponent(AvailabilityDetails);
    LayoutModule.setRightDrawerComponentProps(props);
    LayoutModule.showRightDrawer();
  }

  zoomIn(): void {
    this.timeline?.zoomIn(this.zoomFactor);
  }

  zoomOut(): void {
    this.timeline?.zoomOut(this.zoomFactor);
  }
}
